import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { ChangeRequestTab, ChangeRequestTabRoutes } from '../enum'

@Injectable({ providedIn: 'root' })
export class ChangeRequestNavigationService {
  currentTab: string

  constructor(private router: Router) {}

  selectTab(tab: string) {
    this.currentTab = tab
    const tabParam = ChangeRequestTabRoutes[tab as ChangeRequestTab]
    this.router.navigate([], { queryParams: tabParam ? { tab: tabParam } : null })
  }
}
